import { z } from "zod";
import { validateCallSign } from "@/utils/validation.utils";

export const addressFormSchema = z.object({
  call: z.string().min(1, "呼号不能为空")
    .refine((value) => validateCallSign(value).valid, {
      message: "呼号格式不正确",
    }),
  address: z.string().min(1, "地址不能为空"),
  zip: z.string().regex(/^\d*$/, "邮编只能包含数字")
    .max(10, "邮编最多10位")
    .optional(),
  outsea: z.boolean().default(false),
  status: z.enum(["valid", "invalid"]).default("valid"),
}).refine(
  (data) => {
    if (!data.outsea) {
      return data.zip && data.zip.trim().length > 0;
    }
    return true;
  },
  {
    message: "国内地址邮编不能为空",
    path: ["zip"],
  }
);

export type AddressFormData = z.infer<typeof addressFormSchema>;
